import TravelRuleTable from './TravelRuleTable'

export default TravelRuleTable
